import "./DefaultKPI.css";

import { ReactElement } from "react";

import { Column, Row } from "../../..";

interface DefaultKPIProps {
  iconLeft?: ReactElement;
  iconRight?: ReactElement;
  header: string;
  value: string | number;
  className?: string;
}

export const DefaultKPI = ({ iconLeft, iconRight, header, value, className }: DefaultKPIProps): JSX.Element => {
  return (
    <div className={["DefaultKPIContainer", className].filter(Boolean).join(" ")}>
      <Row spacingV="l" align="center" justify="between">
        <Column span={2}>{iconLeft}</Column>
        <Column span={2} justify="end" hasNoPadding>
          {iconRight}
        </Column>
      </Row>
      <Row spacingV="sl" align="center">
        <Column span={12}>
          <p className="body1Light">{header}</p>
        </Column>
      </Row>
      <Row align="center">
        <Column span={12}>
          <h1>{value}</h1>
        </Column>
      </Row>
    </div>
  );
};
